import { Card, Divider, IconButton, Link, Typography, useTheme } from "@mui/material";
import { Simulado } from "../../services/api/simulados";
import { Delete, Edit } from "@mui/icons-material";
import { EventoBarragem } from "../../services/api/company";
import { useEffect, useState } from "react";
import { BarragemData, useUserContext } from "../../context";
import { useApi } from "../../services";

export const CardSimulado: React.FC<{
  onEdit?: (evento: EventoBarragem) => void;
  onRemove?: (seminario: Simulado) => void;
  simulado: Simulado;
  simuladoAnterior?: Simulado;
}> = ({ simulado, simuladoAnterior, onRemove, onEdit }) => {
  const { palette } = useTheme();
  const user = useUserContext();
  const api = useApi();

  const [barragem, setBarragem] = useState<BarragemData>();

  // Obtendo dados da barragem do simulado
  useEffect(() => {
    api.barragem.getBarragemById(simulado.idBarragem).then(value => {
      if ('error' in value) return;
      setBarragem(value);
    });
  }, [simulado]);

  const handleClick = () => {
    if (simulado.file) window.open(simulado.file, '_blank');
  };


  if (!user || "error" in user) return <Typography fontWeight={700} fontSize={18}>Sem Usuário</Typography>;

  return <Card sx={{
    padding: 2,
    gap: "5px",
    width: "18em",
    display: "flex",
    flexDirection: "column",
    bgcolor: palette.calendario.simuladoCardColor,
  }}>
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <Typography fontWeight={700} fontSize={18}>{`Simulado${barragem?.nome ? ` em ${barragem.nome}` : ""}`}</Typography>
      <div style={{ flex: 1 }} />
      {user.admin && onEdit && <IconButton onClick={() => onEdit({ tipo: "simulado", evento: simulado })} size="small">
        <Edit fontSize="small" />
      </IconButton>
      }
      {user.admin && onRemove &&
        <IconButton onClick={() => onRemove(simulado)} size="small">
          <Delete fontSize="small" />
        </IconButton>
      }
    </div>
    <Divider />
    <Item title="Horário estimando do toque da sirene" value={simulado.data.getHours().toSignificantDigits('horaData') + ":" + simulado.data.getMinutes().toSignificantDigits('minutoData')} />
    {simulado.responsavel && <Item title="Responsável" value={simulado.responsavel} />}
    <Item title="População Estimada" value={(simulado.populacao ?? 0).toString()} />
    {simuladoAnterior && <Item title="Data do último treinamento" value={simuladoAnterior.data.getDate().toSignificantDigits('dia') + "/" + (simuladoAnterior.data.getMonth() + 1).toSignificantDigits('mes') + "/" + simuladoAnterior.data.getFullYear().toString()} />}

    {/* Arquivo */}
    <div style={{ display: "flex", flexDirection: "row" }}>
      <Typography fontWeight={700} fontSize={14}>
        •&nbsp;Arquivo:&nbsp;
      </Typography>
      {
        simulado.file ?
          <Link onClick={handleClick}>acesse aqui</Link> :
          <Typography fontSize={14}>nenhum arquivo</Typography>
      }
    </div>

    {/* Observações por último */}
    {simulado.obs && <Item title="Observações" value={simulado.obs} />}

  </Card>;

};

const Item = ({ title, value }: { title: string; value: string; }) => {
  return <div style={{ display: "flex", flexDirection: "row" }}>
    <Typography fontWeight={700} fontSize={14}>
      •&nbsp;{title}:&nbsp;
    </Typography>
    <Typography fontSize={14}>
      {value}
    </Typography>
  </div>;
};

